/** True when signed in via parent portal (parent selected a child). */
export function isParentPortalSession() {
  if (typeof window === "undefined") return false;
  return (
    localStorage.getItem("ParentPortalMode") === "1" ||
    !!localStorage.getItem("ParentPortalProof")
  );
}

/** Shared auth fields for parent support API calls (matches Diary and other portal APIs). */
export function getStudentSupportApiPayload(extra = {}) {
  const studentId = parseInt(localStorage.getItem("ID"), 10) || 0;
  const isParent = isParentPortalSession();
  const payload = {
    AccessKey: localStorage.getItem("AccessKey"),
    UserID: studentId,
    Student_ID: studentId,
    MemberType: isParent ? "Parent" : "Student",
    ...extra,
  };
  if (isParent) {
    const proof = localStorage.getItem("ParentPortalProof");
    if (proof) {
      payload.ParentProof = proof;
    }
  }
  return payload;
}

export function getSupportApiErrorMessage(err) {
  if (err?.response?.data?.status_message) {
    return err.response.data.status_message;
  }
  if (err?.response?.status === 404) {
    return "Support API not found. Rebuild and restart the API project.";
  }
  if (err?.message) {
    return err.message;
  }
  return "Network error.";
}
